export class Utilities {
  public static EXECUTION_WARNING_MESSAGE = "Following Step(s) contains empty object, please add the details and save the step to remove this valdation " ;
  public static makeid(length) {
     var result           = '';
     var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
     var charactersLength = characters.length;
     for ( var i = 0; i < length; i++ ) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
     }
     return result;
 }

  public static sendKey(keyCode: number){
    var keyboardEvent = document.createEvent("KeyboardEvent");
    var initMethod = typeof keyboardEvent.initKeyboardEvent !== 'undefined' ? "initKeyboardEvent" : "initKeyEvent";

    keyboardEvent[initMethod](
      "keypress",// event type: keydown, keyup, keypress
      true,      // bubbles
      true,      // cancelable
      window,    // view: should be window
      false,     // ctrlKey
      false,     // altKey
      false,     // shiftKey
      false,     // metaKey
      keyCode,   // keyCode: unsigned long - the virtual key code, else 0
      0          // charCode: unsigned long - the Unicode character associated with the depressed key, else 0
    );
    document.dispatchEvent(keyboardEvent);
  }
  public static filterList(list:any[],searchMapkey:string,searchkeyword:string){
    const filterValue = searchkeyword.toLowerCase();
    return list.filter(option => option[searchMapkey].toLowerCase().includes(filterValue))
  }
}
